module.exports = __webpack_public_path__ + "img/users.53140722.svg";